import * as React from 'react';
import getInitial from '../utils/getInitial';
import getPersonaInitialsColorClass from 'fabric-persona/lib/utils/getPersonaInitialsColorClass';
import getPersonaSizeClass from 'fabric-persona/lib/utils/getPersonaSizeClass';
import getTextBoyColor from '../utils/getTextBoyColor';
import { PersonaControlProps } from './PersonaControl.types';

const styles = require('./PersonaPlaceholder.scss');
const classNames = require('classnames/bind').bind(styles);

const PERSONA_SIZE = getPersonaSizeClass(styles);
const PERSONA_INITIALS_COLOR = getPersonaInitialsColorClass(styles);

const PersonaPlaceholder = (props: PersonaControlProps) => {
    const { name, className, size } = props;
    const initials = getInitial(name);
    const textBoyColor = getTextBoyColor(name);
    /**
     * We need onClick handler on Placeholder also because it might be possible
     * that the downloading of the actual Component ie. PersonaControl failed.
     * In that case user will still be able to enter MultiSelect Mode by clicking
     * on this component.
     */
    const onPlaceholderClick = (ev: React.MouseEvent<EventTarget>) => {
        props.onClickPersona(null);
        ev.stopPropagation();
    };

    return (
        <div role="button" className={styles.personaContainer} onClick={onPlaceholderClick}>
            <div className={classNames('ms-Persona', styles.root, className, PERSONA_SIZE[size])}>
                <div className={styles.imageArea}>
                    <div
                        className={classNames(
                            styles.initials,
                            PERSONA_INITIALS_COLOR[textBoyColor]
                        )}
                        aria-hidden="true">
                        <span>{initials}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonaPlaceholder;
